export const toAvailableVariables = (variables = [], source) =>
  variables.map(({ variable_name, example_usage }) => ({
    name: variable_name,
    token: example_usage || `{{${variable_name}}}`,
    source,
  }));

// Delivery channel options. Currently only "Email" is available.
export const NOTIFICATION_TYPES = { EMAIL: "email" };

// When event emails are sent relative to the rule state. Values match the
// backend contract (see event_notification_configurations API).
export const TIMING_OPTIONS = {
  TRIGGERED: "send_on_triggered",
  UNTRIGGERED: "send_on_untriggered",
  BOTH: "send_on_both",
};
